import { getProgressBarStyles, getProgressStyles } from './ProgressBarStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';

const ProgressBar = _ref => {
  let {
    css,
    ...rest
  } = _ref;
  return jsx("div", {
    css: getProgressBarStyles,
    children: jsx("progress", {
      css: [getProgressStyles, css, process.env.NODE_ENV === "production" ? "" : ";label:ProgressBar;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlByb2dyZXNzQmFyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFXc0IiLCJmaWxlIjoiUHJvZ3Jlc3NCYXIudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgUHJvZ3Jlc3NIVE1MQXR0cmlidXRlcywgUmVhY3RFbGVtZW50IH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgV2l0aENvbW1vblByb3BzIH0gZnJvbSAnQHR5cGluZ3MvcHJvcHMnO1xuXG5pbXBvcnQgeyBnZXRQcm9ncmVzc0JhclN0eWxlcywgZ2V0UHJvZ3Jlc3NTdHlsZXMgfSBmcm9tICcuL1Byb2dyZXNzQmFyU3R5bGVzJztcblxuY29uc3QgUHJvZ3Jlc3NCYXIgPSAoe1xuICAgIGNzcyxcbiAgICAuLi5yZXN0XG59OiBXaXRoQ29tbW9uUHJvcHM8UHJvZ3Jlc3NIVE1MQXR0cmlidXRlczxIVE1MUHJvZ3Jlc3NFbGVtZW50Pj4pOiBSZWFjdEVsZW1lbnQgfCBudWxsID0+IHtcbiAgICByZXR1cm4gKFxuICAgICAgICA8ZGl2IGNzcz17Z2V0UHJvZ3Jlc3NCYXJTdHlsZXN9PlxuICAgICAgICAgICAgPHByb2dyZXNzIGNzcz17W2dldFByb2dyZXNzU3R5bGVzLCBjc3NdfSB7Li4ucmVzdH0gLz5cbiAgICAgICAgPC9kaXY+XG4gICAgKTtcbn07XG5cbmV4cG9ydCB7IFByb2dyZXNzQmFyIH07XG4iXX0= */"],
      ...rest
    })
  });
};

export { ProgressBar };
//# sourceMappingURL=ProgressBar.js.map
